import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { trackClicked } from 'utils/analytics/track/trackClicked';
import { trackEventOnce } from 'utils/analytics/track/trackEventOnce';
import { trackDisplayToast } from 'utils/analytics/track/trackToast';
import { dismissToast, showToast } from 'zustand-stores/toastsStore';

export function useMarkAppliedToast() {
  const navigate = useNavigate();

  const showMarkAppliedToastCallback = useCallback(() => {
    trackDisplayToast({
      type: 'success_mark_applied',
      current_page_url: window.location.href,
    });

    showToast({
      actions: [
        {
          label: getText('See All'),
          onClick: () => {
            trackClicked('Action Toast', {
              type: 'success_mark_applied',
              current_page_url: window.location.href,
            });
            dismissToast('success-mark-applied');
            navigate('/dashboard/application-history');
          },
          type: 'button',
        },
      ],
      headline: getText("You've marked this listing as applied"),
      onDismiss: () => {
        trackEventOnce('Dismissed: Action Toast', {
          type: 'success_mark_applied',
          current_page_url: window.location.href,
        });
      },

      dismissible: true,
      durationMs: 15_000,
      id: 'success-mark-applied',
      variant: 'info',
    });
  }, [navigate]);

  return { showMarkAppliedToast: showMarkAppliedToastCallback };
}
